import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  IconButton,
  Button,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Tooltip,
  Chip,
  Alert,
  Snackbar,
  Box
} from '@mui/material';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import InfoIcon from '@mui/icons-material/Info';
import RefreshIcon from '@mui/icons-material/Refresh';
import { format, parseISO } from 'date-fns';
import axios from 'axios';

class RecordedVideos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: [],
      selectedVideo: null,
      openVideoDialog: false,
      isLoading: false,
      error: null,
      snackbar: {
        open: false,
        message: '',
        severity: 'info'
      },
      isDownloading: false,
      downloadingVideoId: null,
      lastRefreshed: null,
      apiRawResponse: null,
      apiResponseStatus: null
    };
  }

  // componentDidMount() {
  //   // Fetch videos when component mounts
  //   this.fetchRecordedVideos();
  // }

  // componentDidUpdate(prevProps) {
  //   // Refetch if PatientID changes
  //   if (prevProps.PatientID !== this.props.PatientID) {
  //     this.fetchRecordedVideos();
  //   }
  // }

  showSnackbar = (message, severity = 'info') => {
    this.setState({
      snackbar: {
        open: true,
        message,
        severity
      }
    });
  };

  closeSnackbar = () => {
    this.setState({
      snackbar: {
        ...this.state.snackbar,
        open: false
      }
    });
  };

  // Phương thức để lấy danh sách video
  fetchRecordedVideos = async () => {
    const { PatientID } = this.props;
    
    console.log(`Fetching videos for patient ID: ${PatientID}`);
    
    if (!PatientID) {
      this.setState({ videos: [] });
      return;
    }
    
    this.setState({ isLoading: true, error: null });
    
    try {
      const url = `https://sperms.ailab.vn:5005/patient-videos/${PatientID}`;
      console.log('Fetching from URL:', url);
      
      // Sử dụng try-catch riêng cho axios để bắt lỗi mạng
      let response;
      try {
        response = await axios.get(url);
      } catch (axiosError) {
        console.error('Axios error:', axiosError);
        
        // Kiểm tra xem có phải lỗi CORS không
        if (axiosError.message && axiosError.message.includes('Network Error')) {
          throw new Error('Lỗi kết nối mạng. Có thể do CORS hoặc server không phản hồi.');
        }
        
        // Bắt các lỗi khác
        throw axiosError;
      }
      
      // Lưu trữ raw response và status để debug
      this.setState({
        apiRawResponse: response.data,
        apiResponseStatus: response.status
      });
      
      console.log('API Response status:', response.status);
      console.log('API Response data:', response.data);
      
      // Kiểm tra xem response và response.data có tồn tại không
      if (!response || !response.data) {
        throw new Error('Không nhận được dữ liệu từ server');
      }
      
      // Xác định mảng videos từ response
      let videosArray = [];
      
      // Kiểm tra các dạng cấu trúc dữ liệu khác nhau
      if (response.data.videos && Array.isArray(response.data.videos)) {
        // Cấu trúc chuẩn {videos: [...]}
        videosArray = response.data.videos;
      } else if (Array.isArray(response.data)) {
        // Response trực tiếp là mảng
        videosArray = response.data;
      } else if (typeof response.data === 'object' && response.data !== null) {
        // Tìm kiếm bất kỳ thuộc tính nào có thể là mảng videos
        const potentialArrayProps = Object.keys(response.data).filter(key => 
          Array.isArray(response.data[key])
        );
        
        if (potentialArrayProps.length > 0) {
          // Ưu tiên thuộc tính có tên liên quan đến video
          const videoRelatedProps = potentialArrayProps.filter(key => 
            key.toLowerCase().includes('video') || 
            key.toLowerCase() === 'data' || 
            key.toLowerCase() === 'results'
          );
          
          if (videoRelatedProps.length > 0) {
            videosArray = response.data[videoRelatedProps[0]];
          } else {
            // Lấy thuộc tính mảng đầu tiên nếu không tìm thấy thuộc tính liên quan đến video
            videosArray = response.data[potentialArrayProps[0]];
          }
        } else {
          console.warn('No array property found in response data');
        }
      }
      
      console.log(`Identified videos array with length: ${videosArray.length}`);
      
      // Chuẩn hóa dữ liệu videos
      const processedVideos = videosArray.map((video, index) => {
        // Nếu video không phải là object, bỏ qua
        if (typeof video !== 'object' || video === null) {
          console.warn(`Invalid video item at index ${index}:`, video);
          return null;
        }
        
        return {
          id: video.id || video.videoId || video._id || `video-${index}`,
          filename: video.filename || `video-${index}.mp4`,
          path: video.path || video.filePath || video.url || '',
          recordDate: video.recordDate || video.createdAt || video.date || new Date().toISOString(),
          fileSize: video.fileSize || video.size || 0,
          sampleID: video.sampleID || video.sample_id || '',
          fileExists: video.hasOwnProperty('fileExists') ? video.fileExists : true
        };
      }).filter(Boolean); // Lọc bỏ các item null
      
      console.log('Processed videos:', processedVideos);
      
      // Cập nhật state với processed videos
      this.setState({
        videos: processedVideos,
        isLoading: false,
        lastRefreshed: new Date()
      }, () => {
        console.log('Updated state videos length:', this.state.videos.length);
      });
      
      // Hiển thị thông báo phù hợp
      if (this.state.lastRefreshed) {
        if (processedVideos.length > 0) {
          this.showSnackbar(`Đã tải ${processedVideos.length} video`, 'success');
        } else {
          this.showSnackbar('Không có video nào được tìm thấy', 'info');
        }
      }
    } catch (error) {
      console.error('Error fetching videos:', error);
      
      // Log chi tiết lỗi
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
      }
      
      this.setState({ 
        isLoading: false,
        error: error.response?.data?.detail || error.message || 'Không thể tải danh sách video',
        videos: [] // Reset videos array to avoid confusion
      });
      
      this.showSnackbar('Lỗi khi làm mới danh sách video: ' + (error.message || ''), 'error');
    }
  };

  handlePlayVideo = (video) => {
    this.setState({
      selectedVideo: video,
      openVideoDialog: true
    });
  };

  handleDownloadVideo = async (video) => {
    try {
      this.setState({ 
        isDownloading: true, 
        downloadingVideoId: video.id 
      });
      
      this.showSnackbar('Đang bắt đầu tải xuống...', 'info');
      
      // Sử dụng videoId hoặc filePath
      const videoId = video.id;
      const fileName = video.filename;
      
      // Sử dụng stream-range endpoint để lấy file
      const response = await axios({
        url: `https://sperms.ailab.vn:5005/stream?file_path=${encodeURIComponent(video.path)}`,
        method: 'GET',
        responseType: 'blob', // Quan trọng để nhận dữ liệu dạng blob
      });
      
      // Tạo URL cho blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      // Tạo phần tử a tạm thời để download
      const link = document.createElement('a');
      link.href = url;
      
      // Đặt tên file cho download
      link.setAttribute('download', fileName);
      
      // Thêm link vào DOM và click
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      this.showSnackbar('Tải xuống hoàn tất', 'success');
    } catch (error) {
      console.error('Error downloading video:', error);
      this.showSnackbar('Lỗi khi tải xuống video: ' + (error.message || 'Không xác định'), 'error');
    } finally {
      this.setState({ 
        isDownloading: false,
        downloadingVideoId: null
      });
    }
  };

  handleDeleteVideo = async (videoId) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa video này?')) {
      this.setState({ isLoading: true });
      
      try {
        await axios.delete(`https://sperms.ailab.vn:5005/delete-video/${videoId}`);
        
        // Đóng dialog nếu đang mở video đó
        if (this.state.selectedVideo && this.state.selectedVideo.id === videoId) {
          this.setState({ openVideoDialog: false, selectedVideo: null });
        }
        
        // Refresh the list after deletion
        this.fetchRecordedVideos();
        this.showSnackbar('Đã xóa video thành công', 'success');
      } catch (error) {
        console.error('Error deleting video:', error);
        this.setState({ isLoading: false });
        this.showSnackbar(
          'Không thể xóa video: ' + (error.response?.data?.detail || 'Lỗi không xác định'),
          'error'
        );
      }
    }
  };

  closeVideoDialog = () => {
    this.setState({
      openVideoDialog: false,
      selectedVideo: null
    });
  };

  formatDate = (dateString) => {
    try {
      return format(parseISO(dateString), 'dd/MM/yyyy HH:mm:ss');
    } catch (error) {
      return dateString;
    }
  };

  formatFileSize = (bytes) => {
    if (!bytes) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  formatDuration = (seconds) => {
    if (!seconds) return 'N/A';
    
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  getLastRefreshedTime = () => {
    if (!this.state.lastRefreshed) return 'Chưa làm mới';
    
    return format(this.state.lastRefreshed, 'HH:mm:ss');
  };

  render() {
    const { 
      videos, 
      selectedVideo, 
      openVideoDialog, 
      isLoading, 
      error, 
      snackbar,
      isDownloading,
      downloadingVideoId
    } = this.state;
    const { PatientID, patientName } = this.props;

    return (
      <Card className="w-full">
        <CardContent className="p-4">
          <Grid container spacing={2}>
            <Grid item xs={12} className="flex justify-between items-center">
              <div>
                <Typography variant="h6" component="h2">
                  Danh sách video đã ghi
                  {isLoading && (
                    <CircularProgress 
                      size={20} 
                      color="primary" 
                      style={{ marginLeft: '10px', verticalAlign: 'middle' }} 
                    />
                  )}
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  {PatientID && patientName ? `Bệnh nhân: ${patientName} (${PatientID})` : 'Chưa chọn bệnh nhân'}
                  {this.state.lastRefreshed && (
                    <span className="ml-2">• Cập nhật lúc: {this.getLastRefreshedTime()}</span>
                  )}
                </Typography>
              </div>
              <Button
                variant="outlined"
                color="primary"
                onClick={this.fetchRecordedVideos}
                disabled={isLoading || !PatientID}
                size="small"
                startIcon={<RefreshIcon />}
              >
                Làm mới
              </Button>
            </Grid>
            
            {error && (
              <Grid item xs={12}>
                <Alert severity="error">{error}</Alert>
              </Grid>
            )}
            
            <Grid item xs={12}>
              <Divider className="my-2" />
            </Grid>
            
            <Grid item xs={12}>
              {console.log('Debug videos state:', videos)}
              {videos.length > 0 ? (
                <List>
                  {videos.map((video, index) => (
                    <React.Fragment key={video.id || index}>
                      <ListItem>
                        <ListItemIcon>
                          <VideoFileIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <div className="flex items-center gap-2">
                              {video.filename} 
                              {!video.fileExists && (
                                <Tooltip title="File không còn tồn tại trên server">
                                  <Chip
                                    size="small"
                                    label="File missing"
                                    color="error"
                                    variant="outlined"
                                  />
                                </Tooltip>
                              )}
                            </div>
                          }
                          secondary={
                            <div>
                              <div>Ngày ghi: {this.formatDate(video.recordDate)}</div>
                              <div>Kích thước: {this.formatFileSize(video.fileSize)}</div>
                              {video.sampleID && <div>Mã mẫu: {video.sampleID}</div>}
                            </div>
                          }
                        />
                        <ListItemSecondaryAction>
                          <Tooltip title="Xem">
                            <span>
                              <IconButton 
                                edge="end" 
                                aria-label="play"
                                onClick={() => this.handlePlayVideo(video)}
                                disabled={!video.fileExists}
                                size="medium"
                              >
                                <PlayArrowIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Tải xuống">
                            <span>
                              <IconButton 
                                edge="end" 
                                aria-label="download"
                                onClick={() => this.handleDownloadVideo(video)}
                                disabled={!video.fileExists || (isDownloading && downloadingVideoId === video.id)}
                                size="medium"
                              >
                                {isDownloading && downloadingVideoId === video.id ? (
                                  <CircularProgress size={24} />
                                ) : (
                                  <DownloadIcon />
                                )}
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Xóa">
                            <IconButton 
                              edge="end" 
                              aria-label="delete"
                              onClick={() => this.handleDeleteVideo(video.id)}
                              size="medium"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </ListItemSecondaryAction>
                      </ListItem>
                      {index < videos.length - 1 && <Divider />}
                    </React.Fragment>
                  ))}
                </List>
              ) : (
                <Box className="py-10 text-center">
                  {PatientID ? (
                    <>
                      <Typography variant="body1" gutterBottom>
                        Không có video nào được ghi
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Hãy bấm nút "Record" để ghi video mới
                      </Typography>
                    </>
                  ) : (
                    <Typography variant="body1">
                      Vui lòng chọn bệnh nhân để xem danh sách video
                    </Typography>
                  )}
                </Box>
              )}
            </Grid>
          </Grid>
        </CardContent>

        {/* Video Playback Dialog */}
        <Dialog
          fullWidth={true}
          maxWidth="lg"
          open={openVideoDialog}
          onClose={this.closeVideoDialog}
          aria-labelledby="video-dialog-title"
        >
          {selectedVideo && (
            <>
              <DialogTitle id="video-dialog-title">
                <div className="flex justify-between items-center">
                  <span>{selectedVideo.filename}</span>
                  <Chip 
                    icon={<InfoIcon />} 
                    label={`Mã mẫu: ${selectedVideo.sampleID || 'N/A'}`}
                    color="primary" 
                    variant="outlined"
                    size="small"
                  />
                </div>
              </DialogTitle>
              <DialogContent>
                <div className="w-full overflow-auto">
                  <video
                    controls
                    autoPlay
                    className="w-full max-w-full h-auto"
                    src={`https://sperms.ailab.vn:5005/stream-range?file_path=${encodeURIComponent(selectedVideo.path)}`}
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </DialogContent>
              <DialogActions className="p-4">
                <Button 
                  onClick={() => this.handleDownloadVideo(selectedVideo)}
                  color="primary"
                  disabled={isDownloading && downloadingVideoId === selectedVideo.id}
                  startIcon={
                    isDownloading && downloadingVideoId === selectedVideo.id ? (
                      <CircularProgress size={20} />
                    ) : (
                      <DownloadIcon />
                    )
                  }
                >
                  {isDownloading && downloadingVideoId === selectedVideo.id ? 'Đang tải...' : 'Tải xuống'}
                </Button>
                <Button
                  onClick={this.closeVideoDialog}
                  color="secondary"
                >
                  Đóng
                </Button>
              </DialogActions>
            </>
          )}
        </Dialog>

        {/* Snackbar for notifications */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={this.closeSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <Alert 
            onClose={this.closeSnackbar} 
            severity={snackbar.severity}
            variant="filled"
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Card>
    );
  }
}

export default RecordedVideos;